import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import cleanseIcon from "../../../../assets/cleanse.png";
import {faIcons} from "../../../../utils/iconConstants";
import {getDollarsFormat} from "./SummaryDisplayFunctions";
import {styleForConfigs} from "../../Components/utils";
import StoreClosedIcon from "./StoreClosedIcon";
import {StoreTotalsCellContextMenu} from "./StoreTotalsCellContextMenu";

const StoreTotalsCell = ({
                             store,
                             date,
                             cell,
                             flags,
                             closures,
                             outlier,
                             displayDataFunction,
                             outlierClassName,
                             retailerId,
                             contextMenuId,
                             setTimestamp,
                             cellValueClicked
                         }) => {
    const cleansed = cell?.cleansed;
    const fill = cell?.fill;
    const cleansedData = displayDataFunction(cleansed, outlier);
    const hasFill = !_.isEmpty(fill);
    const hasDoNotOrAlwaysFill = flags?.doNotFill || flags?.alwaysFill;
    const yagoData = !_.isEmpty(cleansedData) && cleansedData?.includes('$') && cleansed?.yagoDollars ?
        getDollarsFormat(cleansed.yagoDollars) : undefined;

    const cellContainerClassName = [
        outlierClassName,
        styleForConfigs(flags),
        'total-dollars-cell-container'
    ].filter(Boolean).join(' ');

    const trigger = {
        retailerId,
        date,
        storeIds: [store.storeId],
        storeStart: flags?.storeStart,
        storeStop: flags?.storeStop,
        doNotFill: flags?.doNotFill,
        alwaysFill: flags?.alwaysFill,
        storeClosures: closures,
        setTimestamp,
        header: false
    };

    return <StoreTotalsCellContextMenu trigger={trigger} className={cellContainerClassName}
                                       testId={`${contextMenuId}-${date}`}>
        {cleansedData &&
            <div className={'cleanse-cell-details'} data-testid={'cleanse-cell-details'}
                 onClick={() => cellValueClicked(store, cleansed, 'cleansed')}>
                <img alt={'cleanse'} className={'cleanse-icon icon-spacing'} src={cleanseIcon}/>
                <span id={'cleansed'}>{cleansedData}</span>
            </div>}
        {yagoData &&
            <div className={'cleanse-cell-details'} data-testid={'yago-cleanse-cell-details'}>
                <div className={`${faIcons.calendar} cell-font-icon icon-spacing`} title={'YAGO'} data-testid={'yago-icon'}/>
                <span id={'yagoCleansed'}>{yagoData}</span>
            </div>}
        <div>
            {hasDoNotOrAlwaysFill && <div className={`${faIcons.fillDrip} fill-config-icon cell-font-icon icon-spacing`} data-testid={'has-do-not-or-always-fill'}/>}
            {hasFill &&
                <div className={'fill-cell-details'} data-testid={'fill-cell-details'}
                     onClick={() => cellValueClicked(store, fill, 'fill')}>
                    <div id={'has-fill-icon'} className={`${faIcons.fillDrip} cell-font-icon icon-spacing`} data-testid={'has-fill-icon'}/>
                    <span id={'fill'}>{displayDataFunction(fill)}</span>
                </div>
            }
        </div>
        {store.closedDate <= date &&
            <i id={'store-closed'} className={`${faIcons.storeSlash} store-closed-color cell-font-icon`} data-testid={'store-closed'}/>}
        <StoreClosedIcon date={date} storeClosures={closures}/>
    </StoreTotalsCellContextMenu>;
};

StoreTotalsCell.propTypes = {
    store: PropTypes.shape({
        storeId: PropTypes.number,
        storeName: PropTypes.string,
        closedDate: PropTypes.string
    }).isRequired,
    date: PropTypes.string.isRequired,
    cell: PropTypes.shape({
        cleansed: PropTypes.object,
        fill: PropTypes.object
    }),
    flags: PropTypes.shape({
        storeStart: PropTypes.bool,
        storeStop: PropTypes.bool,
        alwaysFill: PropTypes.bool,
        doNotFill: PropTypes.bool
    }),
    closures: PropTypes.arrayOf(PropTypes.object),
    outlier: PropTypes.object,
    displayDataFunction: PropTypes.func.isRequired,
    outlierClassName: PropTypes.string,
    retailerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    contextMenuId: PropTypes.string,
    setTimestamp: PropTypes.func,
    cellValueClicked: PropTypes.func
};

export default React.memo(StoreTotalsCell);
